<template>
  <div class="center-just content1">
    <div class="test ">
      <div class="outer">
        <div class="outer-content ">
          <div class="row">
            <div class="item row">
              <div class="names" style="caret-color: transparent;">姓名:</div>
              <input type="text" class="input" v-model="name" />
            </div>
            <div class="item" style="margin-left: 45px;">
              <div class="names1" style="caret-color: transparent;">
                手机号:
              </div>
              <input
                type="tel"
                class="input"
                maxlength="11"
                required
                v-model="phone"
              />
            </div>
          </div>
          <div class="row" style="margin-top: 18px;">
            <div class="item">
              <select
                name="省"
                id=""
                class="selects"
                @change="provinceChange"
                v-model="province"
              >
                <option
                  :value="pro"
                  v-for="(pro, index) in provinceData"
                  :key="index"
                  >{{ pro }}</option
                >
              </select>
            </div>
            <div class="item" style="margin-left: 45px;">
              <select name="" id="" class="selects" v-model="city">
                <option
                  :value="c"
                  v-for="(c, index) in newCityData"
                  :key="index"
                  >{{ c }}</option
                >
              </select>
            </div>
          </div>
          <div
            class="center"
            style="margin-top: 25px;caret-color: transparent;"
            @click="submit"
          >
            <div class="btn center-just">
              免费领取
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="领取成功"
      :visible.sync="dialogVisible"
      width="30%"
      center
      round
      :modal="false"
    >
      <div class="success">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;感谢您留下姓名和手机号！我们将尽快联系您，为您安排一次免费课程观看体验。我们的工作人员将与您电话沟通，为您提供详细的课程信息，并回答您的任何问题。请保持手机畅通，期待与您电话交流！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import { userPortList } from "@/api/port";
import VDistpicker from "v-distpicker";
import DEFAULT_PROVINCE from "@/units/province";
import DEFAULT_CITY from "@/units/city";
export default {
  components: { VDistpicker },
  data() {
    return {
      provinceData: DEFAULT_PROVINCE,
      cityData: DEFAULT_CITY,
      newCityData: "",
      province: "北京市",
      city: "北京市",
      name: "",
      phone: "",
      dialogVisible: false
    };
  },
  methods: {
    getProvinceCode(name) {
      for (const code in this.provinceData) {
        if (this.provinceData[code] === name) {
          return code;
        }
      }
    },
    provinceChange(e) {
      let code = this.getProvinceCode(this.province);
      this.newCityData = this.cityData[code];
      this.city = this.newCityData[Object.keys(this.newCityData)[0]];
    },
    isValidChinesePhoneNumber(number) {
      const mobileRegExp = /^1[3456789]\d{9}$/;
      const landlineRegExp = /^0\d{2,3}-?\d{7,8}$/;
      return mobileRegExp.test(this.phone) || landlineRegExp.test(this.phone);
    },
    submit() {
      if (this.name) {
        if (this.isValidChinesePhoneNumber()) {
          let params = {
            name: this.name,
            mobile: this.phone,
            province: this.province,
            city: this.city,
            channel: "官网"
          };
          api
            .post(userPortList.postInfo, params)
            .then(res => {
              console.log(res.data);
              this.dialogVisible = true;
              this.name = "";
              this.phone = "";
              this.province = "北京市";
              this.city = "北京市";
            })
            .catch(error => {
              // 捕获异常并处理
              console.error("Error:", error);
            });
        } else {
          this.$message({
            message: "请输入正确的手机号，以便我们能够联系到您！",
            type: "error",
            duration: 5000
          });
        }
      } else {
        this.$message({
          message: "请输入您的姓名，方便之后与您沟通！",
          type: "warning",
          duration: 5000
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.content1 {
  height: 600px;
}
.success {
  line-height: 26px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #4d4d4d;
}
.test {
  width: 1200px;
  height: 500px;

  background-image: url(http://static.smallschoolbag.com/static/noten/website/home/index1_box6_bg.png);
  background-size: 100% 100%;
  border-radius: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  .outer {
    height: 400px;
    width: 780px;
    // background-color: antiquewhite;
    display: flex;
    justify-content: center;
    .outer-content {
      // background-color: red;
      width: 80%;
      height: 62%;
      margin-top: 50px;
      // display: flex;
      // flex-wrap: wrap;
      .item {
        width: 286px;
        height: 64px;
        background: #f5f7ff;
        border: 1px solid #b2c2ff;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .selects {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          background-image: url("http://static.smallschoolbag.com/static/noten/website/home/index1_box6_dropdownbtn.png");
          background-repeat: no-repeat;
          background-position: center right;
          padding-right: 20px;
          height: 40px;
          width: 250px;
          border: none;
          outline: none;
          background-color: #f5f7ff;
          font-size: 16px;
          color: #1966ff;
          cursor: pointer;
        }
        .names {
          width: 42px;
          line-height: 37px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1966ff;
        }
        .names1 {
          width: 60px;
          line-height: 37px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1966ff;
        }
        .input {
          width: 200px;
          height: 60px;
          border: none !important;
          outline-color: invert;
          outline-style: none;
          outline-width: 0px;
          border: none;
          border-style: none;
          text-shadow: none;
          -webkit-appearance: none;
          -webkit-user-select: text;
          outline-color: transparent;
          box-shadow: none;
          background: #f5f7ff;
          // font-weight: bold;
          color: #1a1a1a;
          font-size: 16px;
        }
      }
      .btn {
        background-image: url(http://static.smallschoolbag.com/static/noten/website/home/index1_box6_btn.png);
        background-size: 100% 100%;
        width: 308px;
        height: 88px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 37px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/test.vue